<template>

  <v-snackbar
    v-if='$store.getters.isLoggedIn'
    v-model="isNotificationBarVisible"
    :timeout='defaultTimeout'
    :color='notificationColor'
  >
  <template v-slot:action="{ attrs }">
    <v-btn
      text
      v-bind="attrs"
    >
      Close
    </v-btn>
  </template>

  {{ notificationMsg }}


  </v-snackbar>

</template>


<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NotificationBar',
  computed: {
    ...mapGetters({notificationMsg: 'ui/notificationMsg', notificationLevel: 'ui/notificationLevel'}),
    isNotificationBarVisible: {
      get() {
        return this.$store.getters['ui/isNotificationBarVisible'];
      },
      set(value) {
        console.log(`isNotificationBarVisible new value is: ${value}`);
        this.$store.dispatch('ui/dismissError');
      }
    },
    notificationColor () {
      const notificationLevel = this.$store.getters['ui/notificationLevel'];
      const ret = {
        'INFO': 'green darken-2',
        'ERROR': 'red',
        'WARN': 'orange',
        'DEBUG': 'blue',
        'TRACE': 'purple',
      }[notificationLevel];
      return ret;
    }
  },
  data: () => ({
    defaultTimeout: 6000,
  }),
}

</script>


<style scoped>

</style>
